import { format, addDays } from "date-fns";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { MTableComponent } from "../components/m-table/m-table.component";
import { MarketService } from "../../../../../../../shared/src/lib/services/market.service";
import { genericSort } from "../../../../../../../shared/src/lib/utils/market";
import { AlertComponent } from "../../../../components/alert/alert.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { SportFilterComponent } from "../components/sport-filter/sport-filter.component";
import { BehaviorSubject, combineLatest, Observable, Subject } from "rxjs";
import { LoaderService } from "../../../../../../../shared/src/lib/services/loader.service";
import { AsyncPipe } from "@angular/common";
import { TodayTomorrowLoaderComponent } from "../components/m-table/today-tomorrow-loader/today-tomorrow-loader.component";
import { map, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-tomorrow-markets",
  imports: [MTableComponent, AlertComponent, MatProgressBarModule, SportFilterComponent, AsyncPipe, TodayTomorrowLoaderComponent],
  templateUrl: "./tomorrow-markets.component.html",
  styleUrl: "./tomorrow-markets.component.scss",
})
export class TomorrowMarketsComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  loader = inject(LoaderService);
  marketsBackup: any[] = [];
  markets: any[] = [];
  marketService = inject(MarketService);
  sportFilters$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  $loading!: Observable<boolean>;
  parents: any[] = []; // max no of parents

  ngOnInit() {
    this.$loading = combineLatest([
      this.loader.isLoading("/bf/tomorrow-markets"),
      this.loader.isLoading("/v1/api/navigation_list"),
      this.loader.isLoading("/navigation/event"),
    ]).pipe(map(([loadingMarkets, loadingNavigationList, loadingNavEvents]) => loadingMarkets || loadingNavigationList || loadingNavEvents));
    this.getFilterChanges();
    this.getTomorrowMarkets();
  }

  getFilterChanges() {
    this.sportFilters$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.handleSportFilter(value);
    });
  }

  filterBySport(params: { event: any; filterItem: any }) {
    const filters = [...this.sportFilters$.getValue()].map((item: any) => {
      // console.log(params.filterItem.label === item.label);
      if (params.filterItem.label === item.label) {
        return { ...item, status: params.event.checked };
      } else {
        return item;
      }
    });
    this.sportFilters$.next(filters);
  }

  handleSportFilter(filterValues: any) {
    const selectedSports = filterValues.filter((sport: any) => sport.status).map((sport: any) => sport.label);

    this.markets = this.marketsBackup.filter((market: any) => {
      return selectedSports.includes(market.eventType.name);
    });
  }

  createSportFilters(marketItems: any[]) {
    const uniqueSports = new Set<string>();
    marketItems.forEach((market) => {
      uniqueSports.add(market.eventType.name);
    });

    this.sportFilters$.next(
      Array.from(uniqueSports).map((sport) => ({
        label: sport,
        status: true,
      })),
    );
  }

  getTomorrowMarkets() {
    this.marketService
      .fetchTomorrowMarkets()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          // console.log(response?.data);
          const data = response?.data;
          let marketItems: any[] = [];
          if (data) {
            Object.keys(data).map((key) => {
              const markets = data[key].map((market: any) => ({
                ...market,
                eventName: market?.event?.name,
                sport: market?.eventType?.name,
              }));
              marketItems = [...marketItems, ...markets];
            });
            // console.log(marketItems);
            const today = new Date();
            const tomorrow = addDays(today, 1);
            const tomorrowStr = format(tomorrow, "yyyy-MM-dd");

            marketItems = marketItems.filter((item) => {
              const marketDate = new Date(item.marketStartTime);
              const marketDateStr = format(marketDate, "yyyy-MM-dd");
              return marketDateStr === tomorrowStr;
            });

            this.setMarkets(marketItems);
          }
        },
      });
  }

  setMarkets(markets: any[]) {
    this.createSportFilters(markets);
    this.markets = genericSort(markets, ["marketStartTime", "sport", "eventName"]);
    this.marketsBackup = this.markets;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
